import { ApolloError } from 'apollo-client';
import { EMPTY, Subject, throwError } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { BloqueoModuloError } from '../object/bloqueo-modulo-error.class';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular/Apollo";
import * as i2 from "@angular/router";
import * as i3 from "./bloqueo-modulo.service";
import * as i4 from "ng-uikit-pro-standard";
export class GraphQLClient {
    constructor(apollo, router, bloqueoModuloService, toastService) {
        this.router = router;
        this.bloqueoModuloService = bloqueoModuloService;
        this.toastService = toastService;
        this.destroy$ = new Subject();
        this.router.events.subscribe(() => this.destroy$.next());
        this.apollo = apollo;
    }
    extraerNotificaciones(data) {
        let obj = data;
        let stack = '';
        const retorno = [];
        while (obj != null) {
            // tslint:disable-next-line:forin
            for (const property in obj) {
                if (obj == null) {
                    break;
                }
                if (obj.hasOwnProperty(property)) {
                    if (typeof obj[property] === 'object') {
                        stack = stack + '.' + property;
                        obj = obj[property];
                    }
                    else {
                        if (property === '__typename') {
                            const valor = obj[property];
                            if (valor.startsWith('Notificacion')) {
                                retorno.push(obj);
                                break;
                            }
                        }
                    }
                }
            }
        }
        return retorno;
    }
    alExito(data, onSuccess) {
        onSuccess(data);
        return;
    }
    alError(error) {
        if (error instanceof ApolloError) {
            const httpError = error.networkError;
            if (httpError.status === 401) {
                alert('¡No autorizado!. Por favor inicia sesión nuevamente...');
                //this.router.navigate(['/login']); 
            }
            if (httpError.status === 403) {
                alert('¡No tienes permisos para realizar esta acción!');
                this.router.navigate(['/login']);
            }
        }
        else {
            alert('Ha ocurrido un error, porfavor intentelo mas tarde!');
        }
    }
    watchQuery(options, onSuccess) {
        throw new Error('No implementado aún...!');
    }
    query(options, onSuccess) {
        try {
            const self = this;
            const codigoModuloBloqueado = this.bloqueoModuloService.getCodigoModuloBloqueado();
            // Si el usuario tiene un bloqueo activo
            if (codigoModuloBloqueado) {
                const inputParams = {
                    codigoModulo: codigoModuloBloqueado,
                    rutUsuario: this.bloqueoModuloService.getRutUsuario(),
                };
                this.bloqueoModuloService.verificarBloqueoActualActivo(inputParams).pipe(takeUntil(this.destroy$), switchMap(bloqueo => {
                    if (!this.esMismoModulo(codigoModuloBloqueado)) {
                        return EMPTY; // navegación cambió de módulo; ignorar respuesta tardía
                    }
                    if (bloqueo.exito) {
                        return this.apollo.query(options);
                    }
                    else {
                        return throwError(new BloqueoModuloError(bloqueo.mensajeError));
                    }
                })).subscribe(function (data) {
                    self.alExito(data, onSuccess);
                }, mierror => {
                    console.log({ mierror });
                    if (mierror instanceof ApolloError) {
                        const httpError = mierror.networkError;
                        if (httpError.status === 401) {
                            alert('¡No autorizado!. Por favor inicia sesión nuevamente...');
                            this.router.navigate(['/login']);
                        }
                        if (httpError.status === 403) {
                            alert('¡No tienes permisos para realizar esta acción!');
                            this.router.navigate(['/login']);
                        }
                    }
                    else if (mierror instanceof BloqueoModuloError) {
                        this.handleLockInvalidated(mierror);
                    }
                    else {
                        alert('Ha ocurrido un error, porfavor intentelo mas tarde!');
                    }
                });
            }
            else { // Si el usuario no tiene un bloqueo activo
                this.apollo
                    .query(options)
                    .subscribe(function (data) {
                    self.alExito(data, onSuccess);
                }, mierror => {
                    if (mierror instanceof ApolloError) {
                        const httpError = mierror.networkError;
                        if (httpError.status === 401) {
                            alert('¡No autorizado!. Por favor inicia sesión nuevamente...');
                            this.router.navigate(['/login']);
                        }
                        if (httpError.status === 403) {
                            alert('¡No tienes permisos para realizar esta acción!');
                            this.router.navigate(['/login']);
                        }
                    }
                    else {
                        alert('Ha ocurrido un error, porfavor intentelo mas tarde!');
                    }
                });
            }
        }
        catch (e) {
            this.alError(e);
        }
    }
    mutate(options, onSuccess, controllErrors = true) {
        const codigoModuloBloqueado = this.bloqueoModuloService.getCodigoModuloBloqueado();
        const self = this;
        if (codigoModuloBloqueado) {
            const inputParams = {
                codigoModulo: codigoModuloBloqueado,
                rutUsuario: this.bloqueoModuloService.getRutUsuario(),
            };
            this.bloqueoModuloService.verificarBloqueoActualActivo(inputParams).pipe(takeUntil(this.destroy$), switchMap(bloqueo => {
                if (!this.esMismoModulo(codigoModuloBloqueado)) {
                    return EMPTY; // navegación cambió de módulo; ignorar respuesta tardía
                }
                if (bloqueo.exito) {
                    return this.apollo.mutate(options);
                }
                else {
                    return throwError(new BloqueoModuloError(bloqueo.mensajeError));
                }
            })).subscribe(function (data) {
                self.alExito(data, onSuccess);
            }, mierror => {
                if (mierror instanceof ApolloError) {
                    const httpError = mierror.networkError;
                    if (httpError.status === 401) {
                        alert('¡No autorizado!. Por favor inicia sesión nuevamente...');
                        this.router.navigate(['/login']);
                    }
                    if (httpError.status === 403) {
                        alert('¡No tienes permisos para realizar esta acción!');
                        this.router.navigate(['/login']);
                    }
                }
                else if (mierror instanceof BloqueoModuloError) {
                    console.log('BLOQUEO MODULO ERROR', mierror);
                    this.handleLockInvalidated(mierror);
                }
                else {
                    alert('Ha ocurrido un error, porfavor intentelo mas tarde!');
                }
            });
        }
        else {
            try {
                this.apollo
                    .mutate(options)
                    .subscribe(function (data) {
                    self.alExito(data, onSuccess);
                }, mierror => {
                    if (mierror instanceof ApolloError) {
                        const httpError = mierror.networkError;
                        if (httpError.status === 401) {
                            alert('¡No autorizado!. Por favor inicia sesión nuevamente...');
                            this.router.navigate(['/login']);
                        }
                        if (httpError.status === 403) {
                            alert('¡No tienes permisos para realizar esta acción!');
                            this.router.navigate(['/login']);
                        }
                    }
                    else {
                        alert('Ha ocurrido un error, porfavor intentelo mas tarde!');
                    }
                });
            }
            catch (e) {
                this.alError(e);
            }
        }
    }
    handleLockInvalidated(mierror) {
        this.toastService.clear();
        this.toastService.error(mierror.message, mierror.name);
        this.bloqueoModuloService.forzarLiberacion();
        this.router.navigate(['/']);
    }
    esMismoModulo(expectedModulo) {
        return this.bloqueoModuloService.getCodigoModuloBloqueado() === expectedModulo;
    }
}
GraphQLClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GraphQLClient_Factory() { return new GraphQLClient(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.BloqueoModuloService), i0.ɵɵinject(i4.ToastService)); }, token: GraphQLClient, providedIn: "root" });
